import * as tslib_1 from "tslib";
import { Value } from './value';
import { Text } from './text';
import { Num } from './num';
import { Bool } from './bool';
import { Uri } from './uri';
var Form = (function () {
    function Form() {
    }
    Object.defineProperty(Form.prototype, "tag", {
        get: function () {
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Form.Any = undefined;
    Form.Value = undefined;
    Form.String = undefined;
    Form.Number = undefined;
    Form.Boolean = undefined;
    Form.Uri = undefined;
    return Form;
}());
export { Form };
var AnyForm = (function (_super) {
    tslib_1.__extends(AnyForm, _super);
    function AnyForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AnyForm.prototype, "unit", {
        get: function () {
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    AnyForm.prototype.mold = function (value) {
        return Value.fromAny(value);
    };
    AnyForm.prototype.cast = function (value) {
        return value.toAny();
    };
    return AnyForm;
}(Form));
export { AnyForm };
Form.Any = new AnyForm();
var ValueForm = (function (_super) {
    tslib_1.__extends(ValueForm, _super);
    function ValueForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ValueForm.prototype, "unit", {
        get: function () {
            return Value.Absent;
        },
        enumerable: true,
        configurable: true
    });
    ValueForm.prototype.mold = function (value) {
        return Value.fromAny(value);
    };
    ValueForm.prototype.cast = function (value) {
        return value;
    };
    return ValueForm;
}(Form));
export { ValueForm };
Form.Value = new ValueForm();
var StringForm = (function (_super) {
    tslib_1.__extends(StringForm, _super);
    function StringForm(unit) {
        if (unit === void 0) { unit = ''; }
        var _this = _super.call(this) || this;
        _this.unit = unit;
        return _this;
    }
    StringForm.prototype.mold = function (value) {
        return Text.valueOf(value);
    };
    StringForm.prototype.cast = function (value) {
        return value.target.stringValue();
    };
    return StringForm;
}(Form));
export { StringForm };
Form.String = new StringForm();
var NumberForm = (function (_super) {
    tslib_1.__extends(NumberForm, _super);
    function NumberForm(unit) {
        if (unit === void 0) { unit = 0; }
        var _this = _super.call(this) || this;
        _this.unit = unit;
        return _this;
    }
    NumberForm.prototype.mold = function (value) {
        return Num.valueOf(value);
    };
    NumberForm.prototype.cast = function (value) {
        return value.target.numberValue();
    };
    return NumberForm;
}(Form));
export { NumberForm };
Form.Number = new NumberForm();
var BooleanForm = (function (_super) {
    tslib_1.__extends(BooleanForm, _super);
    function BooleanForm(unit) {
        if (unit === void 0) { unit = false; }
        var _this = _super.call(this) || this;
        _this.unit = unit;
        return _this;
    }
    BooleanForm.prototype.mold = function (value) {
        return Bool.valueOf(value);
    };
    BooleanForm.prototype.cast = function (value) {
        return value.target.booleanValue();
    };
    return BooleanForm;
}(Form));
export { BooleanForm };
Form.Boolean = new BooleanForm();
var UriForm = (function (_super) {
    tslib_1.__extends(UriForm, _super);
    function UriForm(unit) {
        if (unit === void 0) { unit = Uri.Empty; }
        var _this = _super.call(this) || this;
        _this.unit = unit;
        return _this;
    }
    UriForm.prototype.mold = function (uri) {
        return Text.valueOf(uri.toUri());
    };
    UriForm.prototype.cast = function (value) {
        try {
            var str = value.target.stringValue();
            if (str !== undefined) {
                return Uri.parse(str);
            }
        }
        catch (e) {
        }
        return undefined;
    };
    return UriForm;
}(Form));
export { UriForm };
Form.Uri = new UriForm();
//# sourceMappingURL=data:application/json;base64,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